import { BaseControl } from './base-control';

import { SelectControlInterface, SelectOptionInterface } from '../components/select/interfaces';

export class SelectControl extends BaseControl {
  public options: SelectOptionInterface[];
  public multiple: boolean;

  constructor(data: SelectControlInterface) {
    super(data);

    this.options = data.options;
    this.multiple = (typeof data.multiple !== 'undefined') ? data.multiple : false;
  }
}
